/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-22 10:05:42
 * @LastEditors: guanbowen 
 * @LastEditTime: 2023-07-03 10:48:33
 */
const langLabels = {
  dict: {
    dictName: '字典名称',
    dictCode: '字典类型',
    enable: '是否启用',
    describe: '描述',
    defaultValue: '预设值',
    deleted: '是否可删除',
    creatTime: '创建时间',
    creatBy: '创建人',
    dictNamePlaceholder: '请输入字典名称',
    dictCodePlaceholder: '请输入字典类型',
    yes: '是',
    no: '否',
    describePlaceholder: '请输入字典描述',
    addDict: '新增字典',
    editDict: '修改字典',
    statePlaceholder: '请选择状态',
    createBy: '创建人',
    createTime: '创建时间'
  },
  dictValue: {
    add: '新增字典值',
    edit: '修改字典值',
    dictValue: '字典值',
    dictValueName: '字典标签',
    dictValueCode: '字典键值',
    International: '国际化标识',
    sort: '排序',
    dictValueCodePlaceholder: '请输入字典键值',
    dictValueNamePlaceholder: '请输入字典标签',
    InternationalPlaceholder: '请输入国际化标识',
    dictSort: '字典值排序',
    dictSortPlaceholder: '请输入字典值排序'
  },
  user: {
    account: '账户',
    userName: '用户名',
    user: '用户',
    role: '角色',
    nickName: '昵称',
    onlineStatus: '在线状态',
    status: '状态',
    creatTime: '创建时间',
    mima: '密码',
    enterMima: '输入密码',
    mimaLengthPlaceholder: '长度在 8 到 20 个字符',
    mimaMode: '密码8~20位,必须由数字、大小写字母、特殊字符三种组成',
    gender: '性别',
    jobNumber: '工号',
    jobInput: '请输入工号',
    rank: '职级',
    rankSelect: '请选择职级',
    statusJob: '在职状态',
    PleaseEnter: '请输入',
    onlineStatusSelect: '请选择在线状态',
    statusJobSelect: '请选择在职状态',
    pleaseSelect: '请选择',
    loading: '加载中',
    up: '请输入用户名',
    name: '真实姓名',
    userType: '用户类型',
    userTypePlaceholder: '请选择用户类型',
    np: '请输入姓名',
    np2: '请输入昵称',
    userPlaceholder: '请输入用户名',
    userNameTips: '用户名由1-20个字母、数字、下划线组成',
    userLengthPlaceholder: '长度在 1 到 20 个字符',
    chooserole: '选择角色',
    rolename: '角色名',
    usergroup: '用户组',
    choose: '请选择',
    jobName: '岗位信息',
    sort: '序号',
    createDate: '创建日期',
    email: '邮箱地址',
    EmailAddresses: '邮箱地址不合法',
    roleSet: '角色设置',
    jobSet: '岗位设置',
    new: '新增',
    stop: '禁用',
    start: '启用',
    all: '全部',
    resetMima: '重置密码',
    save: '保存',
    cancel: '取消',
    add: '新增用户信息',
    edit: '修改用户信息',
    titleTxt: '提示：以下带 * 项为必填项，请根据操作提示进行操作',
    close: '知道了',
    mimaTxt: '输入密码',
    oldMima: '原密码',
    newMima: '新密码',
    confirm: '确认密码',
    confirmSubmit: '确认',
    confirmTxt: '输入确认密码',
    resetSuccess: '密码重置成功',
    confirmMimaTips: '密码与确认密码不一致',
    deletePrompt: '删除提示',
    deleteSure: '您确定要删除吗?',
    successTips: '操作成功',
    emailTxt: '请输入邮箱地址',
    phoneNumber: '手机号',
    input: '输入手机号',
    PleasePhoneRight: '请输入正确的手机号码',
    level: '用户级别',
    note: '备注',
    baseInfo: '基本信息',
    roleInfo: '角色信息',
    addRole: '新增角色',
    delete: '删除',
    roletext: '请输入角色名称',
    remarktxt: '请输入',
    pleasechooserole: '请选择角色',
    OK: '确定',
    online: '在线',
    offline: '离线',
    man: '男',
    woman: '女',
    onJob: '在职',
    tryOut: '试用',
    practice: '实习',
    dimission: '退休',
    retire: '离职',
    newSuccess: '新增成功',
    editSuccess: '编辑成功',
    jobList: '岗位列表',
    checkDeputyPost: '已选副岗',
    checkMainPost: '已选主岗',
    endData: '结束日期',
    startData: '开始日期',
    batchStart: '批量启用',
    batchStop: '批量停用',
    batchDelete: '批量删除',
    export: '导出',
    exportUserRoles: '导出用户权限'
  },
  dialog: {
    addSupplyClassification: '新增供应商分类',
    addSupplyChildClassification: '新增供应商子分类',
    connectNo: '关联单号',
    parentClass: '上级分类',
    className: '分类名称',
    classCode: '分类编码',
    enable: '是否启用',
    classDesc: '分类说明',
    inputDesc: '请输入供应商分类说明',
    pleaseEnter: '请输入',
    pleaseSelect: '请选择',
    //
    editSupplyClassification: '编辑供应商分类',
  },
  leftPanel: {
    pleaseEnter: '请输入',
    search: '搜索',
    addFirstLevelUnit: '添加一级单位',
    editSort: '编辑排序',
  }
}
export default langLabels
